import React from 'react'
import { Switch, Route, NotFound } from '@fs/zion-router'
import ErrorBoundary from '@fs/zion-error-boundary'

// Dynamically load components to reduce bundle size
// https://reactjs.org/docs/react-api.html#reactlazy

const Landing = React.lazy(() => import('./components/Landing'))

function App() {
  return (
    <ErrorBoundary>
      <Switch>
        <Route exact path="/" component={Landing} />

        {/* blank page for performance testing purposes only */}
        <Route path="/blank" component={() => 'This page is intentionally left blank'} />

        <Route component={NotFound} />
      </Switch>
    </ErrorBoundary>
  )
}
export default App
